var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"busy-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"dots-spinner"},_vm._l((12),function(i){return _c('div',{key:`dots-spinner-${i}`})}),0),_c('p',{directives:[{name:"sanitize-html",rawName:"v-sanitize-html",value:(_vm.message),expression:"message"}]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }